"use client";

import { cn } from "@resume-studio/utils";
import { memo, useState, useEffect } from "react";

type ResponseProps = {
  className?: string;
  children?: string;
};

export const Response = memo(
  ({ className, children, ...props }: ResponseProps) => {
    const [StreamdownComponent, setStreamdownComponent] = useState<any>(null);

    useEffect(() => {
      // Dynamically import Streamdown only on the client side
      const loadStreamdown = async () => {
        try {
          const { Streamdown } = await import("streamdown");
          setStreamdownComponent(() => Streamdown);
        } catch (error) {
          console.warn("Failed to load Streamdown component:", error);
        }
      };

      if (typeof window !== "undefined") {
        loadStreamdown();
      }
    }, []);

    // If Streamdown hasn't loaded yet or failed to load, render nothing
    if (!StreamdownComponent) {
      return null;
    }

    return (
      <StreamdownComponent
        className={cn("size-full [&>*:first-child]:mt-0 [&>*:last-child]:mb-0", className)}
        {...props}
      >
        {children}
      </StreamdownComponent>
    );
  },
  (prevProps, nextProps) => prevProps.children === nextProps.children,
);

Response.displayName = "Response";
